export const TYPE_VETO = 'veto';
export const TYPE_RESTART = 'restart';

const veto = {
  type: TYPE_VETO,
  changesets: []
};

export const raiseVeto = () => {
  throw veto;
};

export const adjustChangesets = (changesets = []) => {
  throw {
    type: TYPE_RESTART,
    changesets
  };
};
